import gql from 'graphql-tag';

import client from '../graphqlAPI';

/*
The shows of a tours post, each with its tickets, for the price advisory in the
post config form.

Two hops, because tickets hold no reference back to their event or post: the
event owns `tickets: [ticketSlugName]`, so the only way in is post -> events ->
tickets. Attribution back to a show relies on `eventSlugName`, which getTickets
resolves through the same join and now reports on the Ticket type — without it
this needed one round trip per show.

Everything resolves to [] rather than throwing. This feeds an advisory line in a
form that must keep working when the query does not.
*/
const GET_EVENTS_BY_POST_SLUG_NAME = gql`
  query getEventsByPostSlugName($postSlugName: String!) {
    getEventsByPostSlugName(postSlugName: $postSlugName) {
      eventSlugName
      beginDateTime
    }
  }
`;

// Note the plural `eventSlugs`: the schema declares getTickets(eventSlugs:
// [String]). The older getTicketsByEventSlugName.js in this folder asks for a
// singular `eventSlug` and does not match.
const GET_TICKETS = gql`
  query getTickets($eventSlugs: [String]) {
    getTickets(eventSlugs: $eventSlugs) {
      ticketSlugName
      eventSlugName
      price
      show
    }
  }
`;

const runQuery = async (query, variables, field) => {
  const result = await client
    .query({
      query,
      variables,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    })
    .catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
      return null;
    });

  return (result && result.data && result.data[field]) || [];
};

const getTourShowsWithTickets = async (postSlugName) => {
  if (!postSlugName) return [];

  try {
    const events = await runQuery(GET_EVENTS_BY_POST_SLUG_NAME, { postSlugName }, 'getEventsByPostSlugName');
    const shows = events.filter(event => event && event.eventSlugName);
    if (!shows.length) return [];

    const tickets = await runQuery(GET_TICKETS, { eventSlugs: shows.map(show => show.eventSlugName) }, 'getTickets');

    return shows.map(show => ({
      eventSlugName: show.eventSlugName,
      beginDateTime: show.beginDateTime,
      tickets: tickets.filter(ticket => ticket && ticket.eventSlugName === show.eventSlugName),
    }));
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getTourShowsWithTickets Error: ${error}`);
    return [];
  }
};

export default getTourShowsWithTickets;
